import { getEngageJourneys } from '../Services/journey';
import { useBizQuery } from './useBizQuery';

const QUERYKEY_ENGAGE_JOURNEYS = 'ENGAGE_JOURNEYS';

export const useGetEngageJourneys = () => {
	const { data, statusState } = useBizQuery([QUERYKEY_ENGAGE_JOURNEYS], () => getEngageJourneys());

	return {
		journeys: data ?? [],
		statusState,
	};
};
